import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { socketContext } from "../../../../../../App";
import { FanGroupContext } from "../../../../../../CustomHelper/Helper";
import ContentLoader from "../../../../../../Screen/ContentLoader";
import NodataAvailable from "../../../../../Common/NodataAvailable";

import FanpostComponent from "./FanpostComponent";

const FanPost = (props) => {
  const [loading, setLoading] = useState(true);
  const { fanPost, setFanPost, fanDetails } = props;
  const { shareCountContext, setShareCountContext } =
    useContext(FanGroupContext);

  const [userId, setFanPostUserId] = useState("");

  const { slug } = useParams();

  const socketData = useContext(socketContext);

  useEffect(() => {
    axios.get(`/api/user/fan/group/post/show/${slug}`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setFanPost(res.data.fanPost);
        setShareCountContext(res.data.fanPost);
        setFanPostUserId(res.data.userId);
      }
    });

    socketData.on("getFanGroupPost", (data) => {
      axios.get(`/api/user/fan/group/post/show/${slug}`).then((res) => {
        setLoading(false);
        if (res.status === 200) {
          setFanPost(res.data.fanPost);
        }
      });
    });
  }, [slug]);

  return (
    <>
      {loading ? (
        <ContentLoader />
      ) : (
        <>
          {fanPost.length === 0 ? (
            <NodataAvailable />
          ) : (
            <>
              {fanPost.map((post, i) => (
                <FanpostComponent userId={userId} post={post} key={i} />
              ))}
            </>
          )}
        </>
      )}
    </>
  );
};

export default FanPost;
